import { render, staticRenderFns } from "./SupplierContainerBoxList.vue?vue&type=template&id=0664b730&"
import script from "./SupplierContainerBoxList.vue?vue&type=script&lang=js&"
export * from "./SupplierContainerBoxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports